import AuthService from './AuthService';
import FlagsService from './FlagsService';
import MeetingService from './MeetingService';
import ModeratorService from './ModeratorService';
import TelecomService from './TelecomService';
import WorkspaceService from './WorkspaceService';
import { axiosInstance } from './axiosConfig';

export const authService = new AuthService(axiosInstance);
export const flagsService = new FlagsService(axiosInstance);
export const meetingService = new MeetingService(axiosInstance);
export const moderatorService = new ModeratorService(axiosInstance);
export const telecomService = new TelecomService();
export const workspaceService = new WorkspaceService(axiosInstance);
